<div *ngIf="!comment" class="flex flex-col w-full text-zen">
    <div class="bg-white rounded border border-exp px-5 pt-1 overflow-hidden ">
        <div class="w-full py-2 text-zen text-sm">
            <textarea class="bg-transparent w-full max-h-48 resize-y" rows="3" [attr.disabled]="countWord(question.answer, lgCount) > lgCount ? true : null"
                [maxlength]="lgCount" (keyup)="countWord(question.answer, lgCount)"
                [placeholder]="'txtSpecifyHere'| translate:language:ModuleNames.Shared" [(ngModel)]="question.answer" matInput></textarea>
        </div>
    </div>
    <h4 *ngIf="question?.answer?.length >= lgCount -20"
        [ngClass]="{'text-zen-red': countWord(question.answer, lgCount)>= lgCount}" class="text-xxs ">
        {{countWord(question.answer, lgCount)}} {{'txtof'| translate:language:ModuleNames.Shared}} {{lgCount}}</h4>

</div>

<div *ngIf="comment" class="flex flex-col w-full text-zen">
    <div [ngClass]="countWord(question.comment, lgCount)> 0?'bg-white':'bg-transparent max-h-12'" class="transition-all duration-300 ease-expo rounded border border-zen border-opacity-10 px-5 pt-1 overflow-hidden ">
        <div class="w-full py-2 text-zen text-sm">
            <textarea class="bg-transparent w-full max-h-48 resize-y" rows="3" [attr.disabled]="countWord(question.comment, lgCount) > lgCount ? true : null"
                [maxlength]="lgCount" (keyup)="countWord(question.comment, lgCount)"
                [placeholder]="'txtTypeComment'| translate:language:ModuleNames.Shared" [(ngModel)]="question.comment" matInput></textarea>
        </div>
    </div>
    <h4 *ngIf="question?.comment?.length >= lgCount - 20"
        [ngClass]="{'text-zen-red': countWord(question.comment, lgCount)>= lgCount}" class="text-xxs ">
        {{countWord(question.comment, lgCount)}} {{'txtof'| translate:language:ModuleNames.Shared}} {{lgCount}}</h4>

</div>